import { cn } from "shared/utils/cn";

type Props<T extends PropertyKey> = {
  steps: T[] | readonly T[];
  activeStep: T;
  onChange: (step: T) => void;
};

export const ProgressBar = <T extends PropertyKey>(props: Props<T>) => {
  const { activeStep, steps, onChange } = props;
  const activeIndex = steps.findIndex((s) => s === activeStep);

  return (
    <div className="relative flex h-6 w-full items-center justify-between">
      <div className="bg-alabaster absolute top-1/2 right-0 left-0 flex h-0.5 -translate-y-1/2" />
      <div
        style={{
          width: `${(activeIndex / (steps.length - 1)) * 100}%`,
        }}
        className="bg-basketBallOrange absolute top-1/2 right-0 left-0 flex h-0.5 -translate-y-1/2"
      />
      {steps.map((step, idx) => {
        return (
          <button
            key={step.toString()}
            onClick={() => {
              onChange(step);
            }}
            className={cn(
              "bg-alabaster border-darkPink relative z-10 size-4.5 cursor-pointer rounded-full border outline-hidden",
              activeIndex >= idx && "bg-persianOrange border-persianOrange"
            )}
          >
            <span
              key={step.toString()}
              className={cn(
                "absolute top-1/2 left-1/2 flex -translate-1/2 items-center justify-center rounded-full bg-transparent",
                activeStep === step && "bg-persianOrange/20 size-6"
              )}
            ></span>
          </button>
        );
      })}
    </div>
  );
};
